import { ActiveConfigType } from '../utils/dataTypes'
import { CDN_CONFIG_PATH, FILES_CDN } from './constants'

class DefaultConfig {
  default: ActiveConfigType
  version: string

  constructor(currentVersion: string) {
    this.version = currentVersion
  }

  async getAppendCDNrequest(filename: string): Promise<Partial<ActiveConfigType> | null> {
    const fullURL: string = CDN_CONFIG_PATH + this.version + filename
    const data = await fetch(fullURL)
    const dataRes = await data.json()
    return dataRes
  }

  async refreshConfig(): Promise<ActiveConfigType | null> {
    const desiredVersion: string = this.version

    try {
      if (FILES_CDN) {
        for (let file of FILES_CDN.split(' ')) {
          const fileURL: string = '/' + file
          const results = await this.getAppendCDNrequest(fileURL)
          this.default = {
            ...this.default, ...results,
          }
        }
      }
      if (this.default.psmProgramMap === undefined ||
        this.default.eventMap === undefined ||
        this.default.environment === undefined ||
        this.default.heartbeatIntervalSeconds === undefined ||
        this.default.psmDeviceMap === undefined) {
        return null
      } else {
        return {
          ...this.default, version: desiredVersion,
        }
      }
    } catch(error) {
      console.error('Error in refreshConfig', error.message)
      return null
    }
  }
}

export default DefaultConfig
